import { toArray, camelCase } from 'lodash';
import { validateEmail } from './validates';

const customizeKeys = (
  obj: Record<string, any> | null,
  customizer: (value: string) => string,
): any => {
  if (!obj || typeof obj !== 'object') return obj;
  const result = {};
  // eslint-disable-next-line no-restricted-syntax
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const camelizedKey = customizer(key);
      // @ts-ignore
      const nestedResult = customizeKeys(obj[key], customizer);
      // @ts-ignore
      result[camelizedKey] = nestedResult;
    }
  }

  return Array.isArray(obj) ? toArray(result) : result;
};

// @ts-ignore
export const camelCaseKeys = (obj: any): any => customizeKeys(obj, camelCase);
// @ts-ignore

export const encodeEmail = (email: string): string | null => {
  if (validateEmail(email)) {
    const idx = email.indexOf('@');
    const subStr = email.substring(0, idx);
    return encodeURIComponent(subStr) + email.substring(idx);
  }
  return null;
};

export const decodeEmail = (email: string | null): string =>
  email ? decodeURIComponent(email) : '';

export const formatPropertyWithEmptyDefaultValue = (
  array: any[],
  property: string,
  defaultValue: any,
) =>
  array.map((item) => ({
    ...item,
    [property]: item[property] || defaultValue,
  }));
